// NotifyBoardList.js
import React from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import CloseIcon from '@mui/icons-material/Close';
import { AppPalette } from '../../model/AppConst';

const InfoTitle = styled(DialogTitle)({
    backgroundColor: '#007', // AppPalette.HeaderBackground,
    color: 'white',
    minWidth: 300,
});

const InfoContentRow = styled(Box)({
    padding: 0, display:'flex'
});

const ContentStyle = {flexGrow:1, overflow:'auto', borderRadius:5, border: AppPalette.BorderCCC, height:300, padding:10};
const TextBox = styled(Box)({...ContentStyle, whiteSpace:'pre-line'});
const MarkdownBox = styled(Box)(ContentStyle);

export default function NotifyBoardItem({
    item,
    open,
    onClose,
    // cvoFiles,
}) {
    const onClickClose = () => {
        // setAdminMode(false);
        onClose();
    };

    
    return (
        <Dialog open={open} onClose={onClickClose} maxWidth="lg">
            <InfoTitle>
                {item.title}

                <IconButton
                    aria-label="close-notify-board-info"
                    onClick={onClickClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </InfoTitle>
            <DialogContent>
                <InfoContentRow style={{marginTop:10}}>
                    {
                        item.textFormat==='markdown'
                        ?
                        <MarkdownBox>
                            <ReactMarkdown>{item.contents}</ReactMarkdown>
                        </MarkdownBox>
                        :
                        <TextBox>{item.contents}</TextBox>
                    }
                </InfoContentRow>
            </DialogContent>
        </Dialog>
    );
}

